import {connect} from 'react-redux';

const mapStateToProps = (state) => ({
    state,
    resources: state ? state.resources : null
});

export default (comp) => connect(mapStateToProps)(comp);



// WEBPACK FOOTER //
// ./app/lib/redux/withResources.js